<template>
    <div>
        <div class="lesson-content-frame" :class="{'container is-max-widescreen': enrollment.course.content_framed}">

            <lesson-header :component="component" :enrollment="enrollment" :outline="outline"/>

<!--            <json-viewer :value="content"/>-->
<!--            <json-viewer :value="blocks"/>-->
<!--            <json-viewer :value="quizResults"/>-->
<!--            <json-viewer :value="enrollment.data"/>-->

            <render-blocks :blocks="blocks" :data="enrollment.data" @saveData="saveData"/>

        </div>

        <div class="content-controls">
            <div class="columns">
                <div class="column is-8">
                    <div v-if="quizGraded">
                        <div class="is-size-6 ml-1">
                            You got <strong>{{quizResults.correct}}</strong> of <strong>{{quizResults.questions}}</strong> questions correct for a score of <strong>{{Math.ceil(quizResults.score * 100)}}%</strong>.

                            <div v-if="parseFloat(content.attributes.minScore) > 0 && Math.ceil(quizResults.score * 100) < parseFloat(content.attributes.minScore)">
                                You must achieve a score of <strong>{{content.attributes.minScore}}%</strong> to continue.  Please retry the assessment.
                            </div>
                        </div>
                    </div>
                </div>
                <div class="column has-text-right">
                    <div v-if="quizGraded">
                        <div v-if="parseFloat(content.attributes.minScore) > 0 && Math.ceil(quizResults.score * 100) < parseFloat(content.attributes.minScore)">
                            <b-button type="is-white" outlined @click="retryQuiz()" class="ml-5">Retry Assessment<i class="fas fa-undo ml-3"></i></b-button>
                        </div>
                        <div v-else>
                            <b-button type="is-white" outlined v-if="outline.prevOutlineId" @click="$emit('goto', outline.prevOutlineId)"><i class="fas fa-arrow-left mr-3"></i>Previous</b-button>
                            <b-button type="is-white" outlined class="ml-5" v-if="outline.completed_at && outline.nextOutlineId" @click="$emit('goto', outline.nextOutlineId)">Next<span v-if="outline.counts.ofSection === outline.counts.totalSection"> Section</span><i class="fas fa-arrow-right ml-3"></i></b-button>
                            <b-button type="is-white" outlined @click="$emit('complete')" class="ml-5" v-if="!outline.completed_at">Complete<span v-if="outline.counts.ofSection === outline.counts.totalSection"> Section</span><i class="fas fa-check ml-3"></i></b-button>
                        </div>
                    </div>
                    <div v-else>
                        <b-button type="is-white" outlined @click="gradeQuiz()" class="ml-5">Grade Assessment<i class="fas fa-list-check ml-3"></i></b-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from "moment";
    import LessonHeader from "./LessonHeader";
    import RenderBlocks from "./RenderBlocks";
    import RenderComponent from "../RenderComponent";

    export default {
        components: {RenderComponent, RenderBlocks, LessonHeader},
        props: ['enrollment', 'component', 'outline', 'time'],
        data: function() {
            return {
                content: {},
                quizGraded: false,
            };
        },
        computed: {
            blocks: function() {
                if (this.content && this.content.content) {
                    return this.content.content;
                } else {
                    return [];
                }
            },
            quizResults: function() {
                let results = {
                    questions: 0,
                    answered: 0,
                    correct: 0,
                    incorrect: 0,
                    score: 0
                };

                for (let i = 0; i < this.blocks.length; i++) {
                    const block = this.blocks[i];
                    if (block.component === 'DropdownField') {
                        results.questions++;

                        if (this.enrollment.data[block.content.id]) {
                            results.answered++;
                            if (this.enrollment.data[block.content.id] === block.content.answer) {
                                results.correct++;
                            } else {
                                results.incorrect++;
                            }
                        }
                    } else if (block.component === 'TextField' || block.component === 'TextArea') {
                        results.questions++;

                        if (this.enrollment.data[block.content.id]) {
                            results.answered++;
                            results.correct++;
                        }
                    }
                }
                results.score = results.correct / results.questions;
                return results;
            }
        },
        methods: {
            saveData(payload) {
                payload.component_id = this.component.id;
                this.$emit('saveData', payload);
            },
            gradeQuiz: function() {
                this.quizGraded = false;
                if (this.quizResults.questions !== this.quizResults.answered) {
                    this.$buefy.toast.open({
                        message: 'Please answer all questions first.',
                        type: 'is-danger',
                        duration: 5000,
                        position: 'is-top-right'
                    });
                } else {
                    for (let i = 0; i < this.blocks.length; i++) {
                        const block = this.blocks[i];

                        if (block.component === 'DropdownField') {
                            if (this.enrollment.data[block.content.id] === block.content.answer) {
                                block.content.graded = 'correct';
                            } else {
                                block.content.graded = 'incorrect';
                                block.content.reveal = this.content.attributes.quizFailReveal;
                            }
                        } else if (block.component === 'TextField' || block.component === 'TextArea') {
                            block.content.graded = 'correct';
                        }

                        console.log(block.component);
                    }

                    this.quizGraded = true;
                }
            },
            retryQuiz: function() {
                for (let i = 0; i < this.blocks.length; i++) {
                    const block = this.blocks[i];

                    if (block.component === 'DropdownField') {
                        if (block.content.graded === 'correct') {
                            if (this.content.attributes.quizRetryResetCorrect) this.enrollment.data[block.content.id] = null;
                        } else {
                            if (this.content.attributes.quizRetryResetIncorrect) this.enrollment.data[block.content.id] = null;
                        }

                        block.content.graded = null;
                        block.content.reveal = false
                    } else if (block.component === 'TextField' || block.component === 'TextArea') {
                        block.content.graded = null;
                        block.content.reveal = false
                    }
                }

                this.quizGraded = false;
            },
        },
        mounted() {
            this.content = (typeof this.component.content === "string") ? JSON.parse(this.component.content) : this.component.content;

            for (let i = 0; i < this.content.content.length; i++) {
                const block = this.content.content[i];
                if (block.component === 'DropdownField') {
                    this.$set(block.content, 'graded', null);
                    this.$set(block.content, 'reveal', false);
                }
            }

            if (this.outline.completed_at) {
                this.gradeQuiz();
            }
        },
    };
</script>

<style lang="scss" scoped>
    .lesson-content-frame {
        position: absolute;
        top: 105px;
        left: 5rem;
        right: 4rem;
        bottom: 7rem;
        background-color: #fff;
        border-radius: 8px;
        box-shadow: 5px 5px 30px 0 rgba(0, 0, 0, 0.3);
        padding: 2rem 2rem 7rem;

        overflow-x: hidden;
        overflow-y: auto;
    }

    .content-controls {
        position: absolute;
        left: 5rem;
        right: 4rem;
        bottom: 1.5rem;
        padding: 3rem 0 1rem;
        font-size: 0.85rem;

        color: white;

        strong {
            color: white;
        }
    }
</style>
